<template>
  <div class="container">
    <form novalidate @submit.prevent="submitEditMailaddress">
      <BreadcrumbGroup :items="breadcrumbItems" />

      <HeadingOne>メールアドレス・お知らせ通知設定の変更</HeadingOne>

      <ErrorsAlert
        :errors="errors"
        :column-only="true"
        :items="inputItemsMb"
      ></ErrorsAlert>

      <WizardGroup class="_mb-md-60 _mb-sm-20">
        <MainWizard :active-index="0" type="useremail"></MainWizard>
      </WizardGroup>

      <p>変更内容をご入力のうえ、「確認画面へ」を押してください。</p>

      <section>
        <TableGroup>
          <TableBox class="_mb-10">
            <TableBody>
              <!-- ローカルログインのメアドは変更不可 -->
              <template v-if="!localUser(userData.id_type)">
                <template
                  v-if="
                    showDefaultMail(
                      userData.ez_mail,
                      userData.mail_1,
                      userData.mail_2
                    )
                  "
                >
                  <TableRow>
                    <TableHeader rowspan="3"> メールアドレス※ </TableHeader>
                    <TableData>
                      {{ displayEzMail(userData.ez_mail) }}
                    </TableData>
                  </TableRow>
                  <TableRow>
                    <TableData>
                      {{ displayMail1(userData.mail_1) }}
                    </TableData>
                  </TableRow>
                  <TableRow>
                    <TableData>
                      {{ displayMail2(userData.mail_2) }}
                    </TableData>
                  </TableRow>
                </template>
              </template>
              <!-- その他のアドレス -->
              <TableRow>
                <TableHeader> メールアドレス </TableHeader>
                <TableData>
                  <div class="_mb-15">
                    {{ displayLoanMailDisp(userData.loan_mail_disp) }}
                  </div>
                  <BtnHelp @click.prevent="showEditMailAddress"
                    >変更する</BtnHelp
                  >
                </TableData>
              </TableRow>
              <TableRow v-show="editMailAddress">
                <TableHeader>
                  変更後のメールアドレス<small class="moji">【半角英数】</small>
                </TableHeader>
                <TableData :has-error="errors['edit_mail']">
                  <InputGroup :errors="errors" :prop-names="['edit_mail']">
                    <InputItem
                      id="edit_mail"
                      v-model="userData.edit_mail"
                      class="-lg"
                      :maxlength="50"
                    ></InputItem>
                    <InputLabel>入力例:****@au.com</InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow v-show="editMailAddress">
                <TableHeader>
                  変更後のメールアドレス<small
                    >（確認用）<small class="moji">【半角英数】</small></small
                  >
                </TableHeader>
                <TableData :has-error="errors['edit_mail_confirmation']">
                  <InputGroup
                    :errors="errors"
                    :prop-names="['edit_mail_confirmation']"
                  >
                    <InputItem
                      id="edit_mail_confirmation"
                      v-model="userData.edit_mail_confirmation"
                      class="-lg"
                      :maxlength="50"
                    ></InputItem>
                    <InputLabel>入力例:****@au.com</InputLabel>
                  </InputGroup>
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader>
                  お知らせ通知設定
                  <btn-tooltip
                    target="noticeTooltip"
                    class="-question"
                  ></btn-tooltip>
                  <tooltips-item
                    target="noticeTooltip"
                    placement="righttop"
                    clazz="question-box"
                  >
                    ・ご案内を希望される内容にチェックをしてください。<br />
                    ・ご不要の場合はチェックを外してください。なお、大切なご案内に関するメールは、変更ができません。
                  </tooltips-item>
                </TableHeader>
                <TableData>
                  <p>
                    現在ご登録いただいているお知らせ通知設定を表示しています。
                  </p>
                  <InputGroup class="row">
                    <div class="col-12 col-md-6 _mb-sm-15 _mb-md-15">
                      <InputCheck
                        id="cpn_ukt_flg"
                        v-model="userData.cpn_ukt_flg"
                        value="1"
                        >キャンペーン情報</InputCheck
                      >
                    </div>
                    <div class="col-12 col-md-6 _mb-sm-15 _mb-md-15">
                      <InputCheck
                        id="kri_tti_ukt_flg"
                        v-model="userData.kri_tti_ukt_flg"
                        value="1"
                        >お借入れ時</InputCheck
                      >
                    </div>
                    <div class="col-12 col-md-6 _mb-sm-15">
                      <InputCheck
                        id="hen_soku_ukt_flg"
                        v-model="userData.hen_soku_ukt_flg"
                        value="1"
                        >ご返済時</InputCheck
                      >
                    </div>
                    <div class="col-12 col-md-6">
                      <InputCheck
                        id="mns_stm_ukt_flg"
                        v-model="userData.mns_stm_ukt_flg"
                        value="1"
                        >マンスリーステートメント発行</InputCheck
                      >
                    </div>
                  </InputGroup>
                </TableData>
              </TableRow>
            </TableBody>
          </TableBox>
        </TableGroup>
        <div class="_mb-md-60 _mb-sm-30">
          <small
            >※au
            IDにご登録の連絡先メールアドレスを表示しております。変更をご希望の場合は、<a
              href="https://id.auone.jp/"
              class="btn-text textlink"
              target="_blank"
              >au IDサイト</a
            >にて連絡先メールアドレスをご登録ください。</small
          >
        </div>

        <BtngroupDouble class="-margin-lg">
          <template #main>
            <BtnMain class="-main" @click.prevent="submitEditMailaddress">
              確認画面へ
            </BtnMain>
          </template>
          <template #back>
            <BtnBack class="-back -sm" router-name="mb023"> 戻る </BtnBack>
          </template>
        </BtngroupDouble>
      </section>
    </form>
  </div>
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import {
  getUserDataForMemberLambdaInvoke,
  editMailaddressLambdaInvoke,
} from "@/utils/LambdaHelper";
import { inputItemsMb } from "@/constants/constant";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage, scrollTop } from "@/utils/Other";
import {
  localUser,
  showDefaultMail,
  displayEzMail,
  displayMail1,
  displayMail2,
  displayLoanMailDisp,
} from "@/utils/UserData";

import ErrorsAlert from "@/components/alert/ErrorsAlert";
import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import BtnTooltip from "@/components/button/BtnTooltip";
import TooltipsItem from "@/components/tooltip/TooltipsItem";
import TableData from "@/components/tables/TableData";
import BtnHelp from "@/components/button/BtnHelp";
import InputGroup from "@/components/input/InputGroup";
import InputItem from "@/components/input/InputItem";
import InputLabel from "@/components/input/InputLabel";
import InputCheck from "@/components/input/InputCheck";
import BtngroupDouble from "@/components/button/BtngroupDouble";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb026",
  components: {
    BtnBack,
    BtnMain,
    BtngroupDouble,
    InputCheck,
    InputLabel,
    InputItem,
    InputGroup,
    BtnHelp,
    TableData,
    TooltipsItem,
    BtnTooltip,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    MainWizard,
    WizardGroup,
    HeadingOne,
    ErrorsAlert,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "メールアドレス・お知らせ通知設定の変更｜お客さま情報の確認・変更",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,お客さま情報",
    });

    return {
      localUser,
      showDefaultMail,
      displayEzMail,
      displayMail1,
      displayMail2,
      displayLoanMailDisp,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "お客さま情報の確認・変更",
          routerName: "mb023",
        },
        {
          text: "メールアドレス・お知らせ通知設定の変更",
          active: true,
        },
      ],
      errors: {},
      showOtherMailAddress: false,
      profile: {
        mail_address: "",
        mail_notice: "",
        // 要確認項目
        other_mail_address: "",
        other_mail_address_confirmation: "",
      },
      isDisabled: false,
      orgLoanMail: "",
      userData: {
        id_type: "",
        ez_mail: "",
        mail_1: "",
        mail_2: "",
        edit_mail: "",
        edit_mail_confirmation: "",
        loan_mail: "",
        loan_mail_confirmation: "",
        loan_mail_disp: "",
        cpn_ukt_flg: "0",
        hen_soku_ukt_flg: "0",
        kri_tti_ukt_flg: "0",
        mns_stm_ukt_flg: "0",
      },
      inputItemsMb: inputItemsMb,
      editMailAddress: false,
    };
  },
  mounted() {
    try {
      getUserDataForMemberLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
          this.orgLoanMail = this.userData.loan_mail;
          if (
            this.userData.loan_mail !== this.userData.loan_mail_confirmation
          ) {
            this.userData.edit_mail = "";
            this.userData.edit_mail_confirmation = "";
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    submitEditMailaddress: function () {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        this.setCheckBoxVal();
        initCredentials()
          .then(() => {
            editMailaddressLambdaInvoke(this.userData)
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else {
                  this.$router.push({ name: "mb029" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    setCheckBoxVal() {
      if (!this.userData.cpn_ukt_flg) this.userData.cpn_ukt_flg = "0";
      if (!this.userData.hen_soku_ukt_flg) this.userData.hen_soku_ukt_flg = "0";
      if (!this.userData.kri_tti_ukt_flg) this.userData.kri_tti_ukt_flg = "0";
      if (!this.userData.mns_stm_ukt_flg) this.userData.mns_stm_ukt_flg = "0";
    },
    showEditMailAddress: function () {
      this.editMailAddress = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.-underline {
  text-decoration: underline;
}
.btn-text {
  &:hover {
    text-decoration: underline;
    color: $orange !important;
  }
}
</style>
